import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useEmbedStore } from '../../lib/embedStore';
import { goBackOrHome } from '../../lib/navigation';

/**
 * Bouton « Retour » affiché uniquement en mode embed (iframe Arsenal/BPM).
 * En mode embed : redirige vers `/my-office`. Sinon utilise `navigate(-1)`.
 */
interface EmbedBackButtonProps {
  fallbackPath?: string;
}

export function EmbedBackButton({ fallbackPath = '/my-office' }: EmbedBackButtonProps) {
  const isEmbed = useEmbedStore((state) => state.isEmbed);
  const navigate = useNavigate();

  if (!isEmbed) return null;

  return (
    <button
      className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1 mb-3"
      onClick={() => {
        if (isEmbed) {
          navigate(fallbackPath);
          return;
        }
        goBackOrHome(navigate);
      }}
      style={{ width: 'fit-content' }}
    >
      <ArrowLeft size={16} />
      Retour
    </button>
  );
}
